import { getChanges, simpleObjectDeepEqual } from 'sinks'
import { definition } from './definition'

const ignoredKeys = ['finalReportSignature', 'finalReportSignatureTime']

/**
 * This function is for when we either want to restore from a backup version of a case
 *
 * @param {{
 *   caseDataToChange: CaseData
 *   caseDataToMatch: CaseData
 * }} opts
 * @returns {any} The changes to be made to the case
 */
export const getChangesToMatchCase = ({
  caseDataToChange,
  caseDataToMatch,
}) => {
  const changesToApply = getChanges(caseDataToChange, caseDataToMatch, {
    includeDeletions: true,
    ignoredKeys,
  })

  // this is a sanity check to make sure we are not about to apply changes that will
  // result in a different caseData than the caseDataToMatch
  // and that the new case data is valid.
  const updated = definition.update(caseDataToChange, changesToApply, true)
  if (!simpleObjectDeepEqual(updated, caseDataToMatch, ignoredKeys)) {
    throw new Error('applied changes to not match caseDataToMatch')
  }

  return changesToApply
}
